import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  const { t } = useTranslation();

  return (
    <section className="relative bg-stone-50 py-16 md:py-24 overflow-hidden">
      {/* Subtle background image */}
      <div className="absolute inset-0 opacity-[0.03]">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20fashion%20layout%20with%20soft%20neutral%20tones%2C%20subtle%20product%20silhouettes%20blurred%20into%20background%2C%20editorial%20style%20texture%2C%20very%20light%20and%20airy%2C%20minimalist%20aesthetic&width=1200&height=800&seq=articles-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      {/* Decorative elements */}
      <div className="absolute top-20 right-10 w-48 h-48 bg-rose-100/30 rounded-full blur-3xl hidden lg:block" />
      <div className="absolute bottom-16 left-8 w-56 h-56 bg-amber-100/25 rounded-full blur-3xl hidden lg:block" />

      <div className="relative z-10 w-full px-6 lg:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-4">
          <div>
            <span className="inline-block px-4 py-1.5 bg-stone-200/60 text-stone-600 text-xs font-medium rounded-full mb-4">
              {t('nav.articles')}
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-medium text-stone-900">
              {t('articles.title')}
            </h2>
          </div>
          <p className="text-sm text-stone-500 max-w-sm">
            {t('articles.subtitle')}
          </p>
        </div>

        {/* Article cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <a
              key={article.slug}
              href={`/article/${article.slug}`}
              className="group bg-white rounded-xl overflow-hidden border border-stone-100 hover:shadow-md transition-shadow"
            >
              {/* Image */}
              <div className="aspect-[16/10] overflow-hidden relative">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                {/* Overlay gradient on hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>

              {/* Content */}
              <div className="p-5">
                <span className="inline-block px-3 py-1 bg-stone-100 text-stone-600 text-xs font-medium rounded-full mb-3">
                  {article.category}
                </span>
                <h3 className="text-base font-semibold text-stone-900 leading-snug group-hover:text-stone-700 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs text-stone-400">
                    {article.readTime} {t('articles.readTime')}
                  </span>
                  <span className="inline-flex items-center gap-1 px-4 py-2 bg-stone-900 text-white text-xs font-medium rounded-full group-hover:bg-stone-800 transition-colors">
                    {t('articles.readMore')}
                    <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}